import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControlLabel, Radio } from '@mui/material';
import axios from 'axios';
import moment from 'moment/moment';
import { CreateChancel, ErrMessage, Loader, NotError } from 'components';
import { FindErrorItem, FindLoad, FindSuccessItem, token, useModal } from 'utils';
import { claimActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, systemActions } from 'store';
import { Skeleton } from '@mui/material';
import { toast } from 'react-toastify';

const typeEnums = {
    OFFICE_ALLY: 'OFFICE_ALLY',
    AVAILITY: 'AVAILITY',
    TL_CLEARINGHOUSE: 'TL_CLEARINGHOUSE',

    // AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL',
    ASPDF: 'ASPDF',
    ASTAB: 'ASTAB',
    ASEDI: 'ASEDI',
    NONE: 'NONE',
};

const ACTION_TYPE = 'SUBMIT_CLAIM';
const INTEGRATION_ACTION_TYPE = 'CAN_USE_INTEGRATION';
export const ResubmitClaim = ({ selectedList, afterSuccess, submitTitle }) => {
    const { close } = useModal();
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);
    const backError = FindErrorItem(ACTION_TYPE);
    const dispatch = useDispatch();
    const [error, setError] = useState(false);
    const loader = FindLoad(ACTION_TYPE);
    const loadIntegrations = FindLoad(INTEGRATION_ACTION_TYPE);
    const [inputs, setInputs] = useState({
        downloadType: typeEnums.NONE,
    });
    const [loadDownload, setLoadDownload] = useState(false);
    const success = FindSuccessItem(ACTION_TYPE);

    useEffect(() => {
        dispatch(systemActions.canUseIntegration());
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            if(inputs?.downloadType === typeEnums.NONE){
                afterSuccess && afterSuccess();
            }
        }
    }, [success]);

    const handleDownload = () => {
        if (!inputs?.type) {
            setError(true);
            return;
        }
        if (inputs?.type === typeEnums.OFFICE_ALLY || inputs?.type === typeEnums.AVAILITY || inputs?.type === typeEnums.TL_CLEARINGHOUSE) {
            dispatch(claimActions.submitClaim(selectedList, '', inputs?.type));
            return;
        }

        if (inputs?.downloadType === typeEnums.NONE) {
            dispatch(claimActions.submitClaim(selectedList, ''));
            return;
        }

        const enumType = inputs?.downloadType === typeEnums.ASPDF ? 'PDF' : inputs?.downloadType === typeEnums.ASEDI ? 'EDI' : 'TAB';

        setLoadDownload(true);
        axios({
            url: `/claim/1500Forms/${enumType}`,
            method: 'POST',
            responseType: 'blob',
            headers: {
                'access-token': `${token()}`,
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({ claimIds: selectedList }),
        })
            .then((response) => {
                setLoadDownload(false);
                const fileBlob = new Blob([response?.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(fileBlob);
                const link = document.createElement('a');
                link.href = url;
                const fileType =
                    inputs?.downloadType === typeEnums.ASPDF ? 'pdf' : inputs?.downloadType === typeEnums.ASEDI ? 'edi' : 'tab';
                link.setAttribute('download', `${moment().format('MM/DD/YYYY')}-1500Form.${fileType}`);
                document.body.appendChild(link);
                link.click();
                if (inputs?.downloadType === typeEnums.ASPDF) {
                    window.open(url, '_blank', 'noopener,noreferrer');
                }
                close();
                afterSuccess && afterSuccess();
            })
            .catch((err) => {
                let message = err?.data?.message || 'Something went wrong';

                toast(<NotError type={'error'} errMessage={message} />);
                setLoadDownload(false);
                close();
                afterSuccess && afterSuccess();
            });
    };

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        setError(false);
    };

    const integrationsList = [
        {
            type: typeEnums.OFFICE_ALLY,
            label: 'Submit via Office Ally (Automatic)',
            canUse: !canUseIntegrations?.activeOfficeAllySFTP,
            name: 'Office Ally',
        },
        {
            type: typeEnums.AVAILITY,
            label: 'Submit via Availity (Automatic)',
            canUse: !canUseIntegrations?.activeAvaility,
            name: 'Availity',
        },
        {
            type: typeEnums.TL_CLEARINGHOUSE,
            label: 'Submit via TherapyLake (Automatic)',
            canUse: !canUseIntegrations?.activeTlClearinghouse,
            name: 'TherapyLake',
        },
    ];

    return (
        <div style={{ width: 400 }}>
            <p className="download-modal-title">{submitTitle ? submitTitle : 'Select Submission Method'}</p>
            <p className="download-modal-desc">Please choose how you would like to submit the selected claims</p>
            <div className="download-1500form-modal-body">
                {loadIntegrations?.length ? (
                    <div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                        <div className="form-type-box-passive" style={{ padding: 0, marginBottom: '12px' }}>
                            <Skeleton variant="rounded" width={'100%'} height={96} />
                        </div>
                    </div>
                ) : (
                    <div>
                        {integrationsList?.map((i, j) => (
                            <div
                                key={j}
                                className={inputs?.type === i?.type ? 'form-type-box-active' : 'form-type-box-passive'}
                                style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}
                            >
                                <FormControlLabel
                                    style={{ opacity: i?.canUse ? 0.5 : 1 }}
                                    disabled={i?.canUse}
                                    onChange={handleChange}
                                    name={'type'}
                                    value={i?.type}
                                    label={i?.label}
                                    control={
                                        <Radio
                                            style={{ color: inputs?.type === i?.type ? '#347AF0' : '#D0D5DD' }}
                                            checked={inputs?.type === i?.type}
                                        />
                                    }
                                />
                                {i?.canUse && (
                                    <p className="office-ally-warning-text">
                                        {`Please enable ${i?.name} integration in`}
                                        <a
                                            style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }}
                                            href={'/system'}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                        >
                                            {' '}
                                            settings{' '}
                                        </a>
                                        to submit claims.
                                    </p>
                                )}
                            </div>
                        ))}

                        {/*<div*/}
                        {/*    className={inputs?.type === typeEnums.OFFICE_ALLY ? 'form-type-box-active' : 'form-type-box-passive'}*/}
                        {/*    style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}*/}
                        {/*>*/}
                        {/*    <FormControlLabel*/}
                        {/*        style={{ opacity: !canUseIntegrations?.activeOfficeAllySFTP ? 0.5 : 1 }}*/}
                        {/*        disabled={!canUseIntegrations?.activeOfficeAllySFTP}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        name={'type'}*/}
                        {/*        value={typeEnums.OFFICE_ALLY}*/}
                        {/*        label="Submit via Office Ally (Automatic)"*/}
                        {/*        control={<Radio*/}
                        {/*            style={{ color: inputs?.type === typeEnums.OFFICE_ALLY ? '#347AF0' : '#D0D5DD' }}*/}
                        {/*            checked={inputs?.type === typeEnums.OFFICE_ALLY}*/}
                        {/*        />}*/}
                        {/*    />*/}
                        {/*    {!canUseIntegrations?.activeOfficeAllySFTP &&*/}
                        {/*        <p className="office-ally-warning-text">*/}
                        {/*           Please enable Office Ally integration in*/}
                        {/*            <a style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }} href={'/system'}*/}
                        {/*               target={'_blank'}> settings </a>*/}
                        {/*            to submit claims.*/}
                        {/*        </p>*/}
                        {/*    }*/}
                        {/*</div>*/}

                        {/*<div*/}
                        {/*    className={inputs?.type === typeEnums.AVAILITY ? 'form-type-box-active' : 'form-type-box-passive'}*/}
                        {/*    style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}*/}
                        {/*>*/}
                        {/*    <FormControlLabel*/}
                        {/*        // style={{ opacity: !canUseIntegrations?.availity ? 0.5 : 1 }}*/}
                        {/*        style={{ opacity: !canUseIntegrations?.activeAvaility ? 0.5 : 1 }}*/}
                        {/*        disabled={!canUseIntegrations?.activeAvaility}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        name={'type'}*/}
                        {/*        value={typeEnums.AVAILITY}*/}
                        {/*        label="Submit via Availity (Automatic)"*/}
                        {/*        control={<Radio*/}
                        {/*            style={{ color: inputs?.type === typeEnums.AVAILITY ? '#347AF0' : '#D0D5DD' }}*/}
                        {/*            checked={inputs?.type === typeEnums.AVAILITY}*/}
                        {/*        />}*/}
                        {/*    />*/}
                        {/*    {!canUseIntegrations?.activeAvaility &&*/}
                        {/*        <p className="office-ally-warning-text">*/}
                        {/*            Enable Availity integration in*/}
                        {/*            <a style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }} href={'/system'}*/}
                        {/*               target={'_blank'}>*/}
                        {/*                settings </a> to submit claims.*/}
                        {/*        </p>*/}
                        {/*    }*/}
                        {/*</div>*/}

                        {/*<div*/}
                        {/*    className={inputs?.type === typeEnums.TL_CLEARINGHOUSE ? 'form-type-box-active' : 'form-type-box-passive'}*/}
                        {/*    style={{ marginBottom: '12px', borderColor: error ? '#F07379' : '' }}*/}
                        {/*>*/}
                        {/*    <FormControlLabel*/}
                        {/*        style={{ opacity: !canUseIntegrations?.activeTlClearinghouse ? 0.5 : 1 }}*/}
                        {/*        disabled={!canUseIntegrations?.activeTlClearinghouse}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        name={'type'}*/}
                        {/*        value={typeEnums.TL_CLEARINGHOUSE}*/}
                        {/*        label="Submit via TherapyLake (Automatic)"*/}
                        {/*        control={<Radio*/}
                        {/*            style={{ color: inputs?.type === typeEnums.TL_CLEARINGHOUSE ? '#347AF0' : '#D0D5DD' }}*/}
                        {/*            checked={inputs?.type === typeEnums.TL_CLEARINGHOUSE}*/}
                        {/*        />}*/}
                        {/*    />*/}
                        {/*    {!canUseIntegrations?.activeTlClearinghouse &&*/}
                        {/*        <p className="office-ally-warning-text">*/}
                        {/*            Enable TherapyLake integration in*/}
                        {/*            <a style={{ margin: '0 4px', color: '#172B4D', fontWeight: 600 }} href={'/system'}*/}
                        {/*               target={'_blank'}>*/}
                        {/*                settings </a> to submit claims.*/}
                        {/*        </p>*/}
                        {/*    }*/}
                        {/*</div>*/}
                    </div>
                )}

                <div
                    className={inputs?.type === typeEnums.MANUAL ? 'form-type-box-active' : 'form-type-box-passive'}
                    style={{ borderColor: error ? '#F07379' : '' }}
                >
                    <FormControlLabel
                        onChange={handleChange}
                        name={'type'}
                        value={typeEnums.MANUAL}
                        label="Manual Submission"
                        control={
                            <Radio
                                style={{ color: inputs?.type === typeEnums.MANUAL ? '#347AF0' : '#D0D5DD' }}
                                checked={inputs?.type === typeEnums.MANUAL}
                            />
                        }
                    />
                    {inputs?.type === typeEnums.MANUAL && (
                        <div className="download-manual-types-body">
                            {[
                                { value: typeEnums.NONE, label: 'None (Skip)' },
                                { value: typeEnums.ASPDF, label: 'Download as PDF' },
                                { value: typeEnums.ASTAB, label: 'Tab-delimited (.tab)' },
                                { value: typeEnums.ASEDI, label: 'ASC X12 (.edi)' },
                            ].map(({ value, label }) => (
                                <FormControlLabel
                                    key={value}
                                    style={{ color: '#172B4D', width: 160 }}
                                    onChange={handleChange}
                                    name="downloadType"
                                    value={value}
                                    label={label}
                                    control={
                                        <Radio
                                            style={{
                                                color: inputs?.downloadType === value ? '#347AF0' : '#D0D5DD',
                                                fontSize: 12,
                                            }}
                                            checked={inputs?.downloadType === value}
                                        />
                                    }
                                />
                            ))}
                        </div>
                    )}
                </div>
                <ErrMessage
                    style={{ marginBottom: '12px' }}
                    text={error ? 'Please select method' : backError?.error ? backError?.error : ''}
                />
            </div>

            <div>
                <CreateChancel
                    loader={loadDownload || loader?.length}
                    disabled={loadIntegrations?.length}
                    create={'Submit'}
                    chancel={'Cancel'}
                    onCreate={handleDownload}
                    onClose={close}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
